/**
 * @generated SignedSource<<dccaa946a5fde03b086e38ba9830d76d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type HomePanelGroupType = "MEETINGS" | "ONE_ON_ONE" | "OTHER_STREAMS" | "REGULAR" | "TEAMS";
import { FragmentRefs } from "relay-runtime";
export type HomePanelGroupsMenu_viewer$data = {
  readonly homePanelGroups: ReadonlyArray<{
    readonly emojiName: string | null;
    readonly id: string;
    readonly name: string;
    readonly type: HomePanelGroupType;
  } | null> | null;
  readonly " $fragmentType": "HomePanelGroupsMenu_viewer";
};
export type HomePanelGroupsMenu_viewer$key = {
  readonly " $data"?: HomePanelGroupsMenu_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HomePanelGroupsMenu_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomePanelGroupsMenu_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HomePanelGroup",
      "kind": "LinkedField",
      "name": "homePanelGroups",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emojiName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2c45f4cb9e8ae6a03f4720cd46ded558";

export default node;
